import React from 'react'
import { Box } from "@mui/material";
import PageBanner from "../../../../common/components/PageBanner";
import androidplaystore from "../../../../assets/playstore-android.png"
import appleplaystore from "../../../../assets/appleplaystore.png"
import centerImage from "../../../../assets/new-images/myPlan.png"
import TrialCta from '../../../../common/components/TrialCta';
import '../../OurService/styles/services.css'

// Grouped per the refresh handoff. Keep claims to shipped behavior: real-time
// alerts, emergency-service integrations, and storage/security claims are on
// the "hold until confirmed" list and stay off this page until approved.
const featureGroups = [
  { title: "Planning", body: "Build a household plan with the people in your home, your meeting places, and the hazards relevant where you live." },
  { title: "Contacts", body: "Keep emergency contacts together so everyone knows who to call and who checks on whom." },
  { title: "Records", body: "Organize important documents so they are easier to find when you need them." },
  { title: "Inventory", body: "Record home and property details to help you organize recovery." },
  { title: "Pets", body: "Add pet details such as medications, diets, and microchip numbers." },
  { title: "Communication", body: "Invited family members can check in and message one another in the MYREDFOLDER app." },
  { title: "Recovery", body: "Keep the information you'll need after an emergency in one place, and update the plan as life changes." },
];

const MyRedFolderPlan = () => {
  return (
    <div>
    <Box>
      <PageBanner
        image={centerImage}
        alt="A family on a sofa marking meeting places on a neighborhood map, with go-kit supplies on the table."
        eyebrow="Our Services"
        title="MYREDFOLDER® Plan"
        fade
      />

      <section className="mrf-section">
        <div className="mrf-container">
          <p className="mrf-lead" style={{ maxWidth: 880, color: "var(--mrf-ink)" }}>
            Create a household plan that answers the questions that matter when routines break down. Add contacts,
            meeting places, and relevant hazards; organize records and property information; review the plan with your
            family.
          </p>
          <div style={{ marginTop: 8 }}>
            <TrialCta liveLabel="Build your family plan" fallbackLabel="See Premium membership" />
          </div>
        </div>
      </section>

      <section className="mrf-section mrf-section--alt">
        <div className="mrf-container">
          <h2 className="mrf-heading">What your plan includes</h2>
          <p className="mrf-lead">Seven areas, kept together so nothing is scattered when you need it.</p>
          <ol className="mrf-grid-3" style={{ listStyle: "none", padding: 0, margin: "24px 0 0" }}>
            {featureGroups.map((f, i) => (
              <li key={f.title} className="mrf-card">
                <span className="mrf-step__num" aria-hidden="true">{i + 1}</span>
                <h3 className="mrf-card__title">{f.title}</h3>
                <p className="mrf-card__body">{f.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="mrf-section">
        <div
          className="mrf-container"
          style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 24 }}
        >
          <div style={{ maxWidth: 520 }}>
            <h2 className="mrf-heading" style={{ marginBottom: 8 }}>Take your plan with you</h2>
            <p className="mrf-body" style={{ margin: 0 }}>The MYREDFOLDER app is included with Premium membership.</p>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center" }}>
            <img src={appleplaystore} alt="Download on the App Store" style={{ height: 52, width: "auto" }} />
            <img src={androidplaystore} alt="Get it on Google Play" style={{ height: 52, width: "auto" }} />
          </div>
        </div>
      </section>
        </Box>
    </div>
  )
}

export default MyRedFolderPlan;
